/**
 * @typedef {Object} CreateParcelBookingOutputView
 * @property {number} parcelId
 * @property {string} userId
 * @property {string} password
 * @property {string} userType
 * @property {string} message
 * @property {string} barcode
 * @property {string} recordSerialNo
 */

/** @typedef {CreateParcelBookingOutputView[]} ParcelBookingCreatedPayload */

/** @deprecated Use getParcelBookingCreatedGroupName(userId) */
export const PARCEL_BOOKING_CREATED_GROUP = "ParcelBookingCreated";

export const PARCEL_BOOKING_CREATED_GROUP_PREFIX = "ParcelBookingCreated_";

/**
 * Hub group per admin user — matches backend SendToGroupAsync group name.
 * @param {string} userId
 */
export function getParcelBookingCreatedGroupName(userId) {
  const id = userId != null ? String(userId).trim() : "";
  if (!id) return "";
  return `${PARCEL_BOOKING_CREATED_GROUP_PREFIX}${id}`;
}

export const CUSTOMER_GROUP_PREFIX = "CustomerGroup_";

/**
 * Customer (User role) SignalR group — CustomerGroup_{UserId}
 * @param {string} userId
 */
export function getCustomerGroupName(userId) {
  const id = userId != null ? String(userId).trim() : "";
  if (!id) return "";
  return `${CUSTOMER_GROUP_PREFIX}${id}`;
}

/** Client event — matches SendToGroupAsync method on backend (NewBookingCreated). */
export const NEW_BOOKING_CREATED_EVENT = "NewBookingCreated";

/** Client event — parcel status updates for CustomerGroup_{UserId}. */
export const PARCEL_STATUS_UPDATE_EVENT = "ParcelStatusUpdate";

/** @deprecated Use NEW_BOOKING_CREATED_EVENT */
export const PARCEL_BOOKING_CREATED_EVENT = NEW_BOOKING_CREATED_EVENT;

/** Hub method that adds the connection to a named group (backend). */
export const SIGNALR_JOIN_GROUP_METHOD = "JoinGroup";

export const SIGNALR_LEAVE_GROUP_METHOD = "LeaveGroup";

export const PARCEL_BOOKING_REFRESH_EVENT = "parcel-booking-created";
